<app-breadcrumb [title]="'branch'|translate" [items]="['security'|translate]" [active_item]="'branch'|translate"></app-breadcrumb>
<div class="container-fluid">
    <div class="edit-profile">

        <form class="row" [formGroup]="branchForm" (ngSubmit)="onFormSubmit()" id="ngForm">

            <div class="col-xl-10">
                <div class="card">
                    <!--<div class="card-header">
                        <h5 class="card-title mb-0 f-w-700">{{ 'form'|translate }}</h5>
                        <div class="card-options">
                            <a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
                        </div>
                    </div>-->

                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-4">
                                <label class="form-label">{{ 'institution'|translate }} <span class="text-danger">*</span></label>
                                <ng-select
                                        [items]="institutions"
                                        bindLabel="name"
                                        bindValue="id"
                                        placeholder="{{ 'choose institution'|translate }}"
                                        formControlName="institution"
                                        [ngClass]="{'is-invalid': fc['institution'].invalid && isSubmitted}"
                                        [(ngModel)]="institutionSelected">
                                </ng-select>
                                <div class="invalid-feedback fst-italic" *ngIf="fc['institution'].errors?.['required']">{{'this field is required'|translate}}</div>
                                <div class="invalid-feedback fst-italic" *ngIf="fc['institution'].errors?.['serverError']">
                                    {{ fc['institution'].errors?.['serverError'] }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">{{ 'code'|translate }} <span class="text-danger">*</span></label>
                                <input class="form-control form-control-sm" type="text" placeholder="Ex. BP-DLA" formControlName="code" [ngClass]="{'is-invalid': fc['code'].invalid && isSubmitted}">
                                <small class="invalid-feedback fst-italic" *ngIf="fc['code'].errors?.['required']">{{'this field is required'|translate}}</small>
                                <div class="invalid-feedback fst-italic" *ngIf="fc['code'].errors?.['serverError']">
                                    {{ fc['code'].errors?.['serverError'] }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">{{ 'name'|translate }} <span class="text-danger">*</span></label>
                                <input class="form-control form-control-sm" type="text" placeholder="Ex. Better Planning Douala" formControlName="name" [ngClass]="{'is-invalid': fc['name'].invalid && isSubmitted}">
                                <small class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['required']">{{'this field is required'|translate}}</small>
                                <div class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['serverError']">
                                    {{ fc['name'].errors?.['serverError'] }}
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-4">
                                <label class="form-label">{{ 'email'|translate }} </label>
                                <input class="form-control form-control-sm" type="text" placeholder="Ex. jdoe@bp.com" formControlName="email" [ngClass]="{'is-invalid': fc['email'].invalid && isSubmitted}">
                                <small class="invalid-feedback fst-italic" *ngIf="fc['email'].errors?.['email']">{{'email must be with mail convention'|translate}}</small>
                                <div class="invalid-feedback fst-italic" *ngIf="fc['email'].errors?.['serverError']">
                                    {{ fc['email'].errors?.['serverError'] }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">{{ 'phone'|translate }} </label>
                                <input class="form-control form-control-sm" type="text" placeholder="Ex. 677777777" formControlName="phone" [ngClass]="{'is-invalid': fc['phone'].invalid && isSubmitted}">
                                <div class="invalid-feedback fst-italic" *ngIf="fc['phone'].errors?.['serverError']">
                                    {{ fc['phone'].errors?.['serverError'] }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">{{ 'address'|translate }} </label>
                                <input class="form-control form-control-sm" type="text" placeholder="Ex. BP 237 Bonamoussadi Douala" formControlName="address" [ngClass]="{'is-invalid': fc['address'].invalid && isSubmitted}">
                                <div class="invalid-feedback fst-italic" *ngIf="fc['address'].errors?.['serverError']">
                                    {{ fc['address'].errors?.['serverError'] }}
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-4">
                                <label class="form-label">{{ 'NSIF Employer Mat No.'|translate }} </label>
                                <input class="form-control form-control-sm" type="text" placeholder="Ex. 33019" formControlName="nsifEmployerMatriculeNo" [ngClass]="{'is-invalid': fc['nsifEmployerMatriculeNo'].invalid && isSubmitted}">
                                <div class="invalid-feedback fst-italic" *ngIf="fc['nsifEmployerMatriculeNo'].errors?.['serverError']">
                                    {{ fc['nsifEmployerMatriculeNo'].errors?.['serverError'] }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">{{ 'price list'|translate }}</label>
                                <ng-select
                                        [items]="priceLists"
                                        bindLabel="name"
                                        bindValue="id"
                                        [multiple]="true"
                                        placeholder="{{ 'choose a price list'|translate }}"
                                        formControlName="priceLists"
                                        [(ngModel)]="priceListSelected">
                                </ng-select>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">{{ 'enable ?'|translate }} <span class="text-danger">*</span></label>
                                <div class="btn-radio" >
                                    <div class="btn-group" data-bs-toggle="buttons">
                                        <div class="btn btn-light txt-dark">
                                            <div class="radio radio-dark">
                                                <input id="radio21" formControlName="isEnable" type="radio" value='1'>
                                                <label for="radio21">{{ 'yes'|translate }}</label>
                                            </div>
                                        </div>
                                        <div class="btn btn-light txt-dark">
                                            <div class="radio radio-dark">
                                                <input id="radio22" formControlName="isEnable" type="radio" value='0'>
                                                <label for="radio22">{{ 'no'|translate }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="card-footer text-end">
                        <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-primary" [disabled]=saving>
                            <ng-container *ngIf="!saving; else isSaving">{{update}}</ng-container>
                            <ng-template #isSaving>
                                {{ "submitting" | translate}} ...
                            </ng-template>
                        </button>
                        <button  type="button" class="btn btn-sm btn-outline-dark" routerLink='/security/branch'>
                            <i class="icofont icofont-ui-close" style="margin-right: 2px;"></i>
                            {{ 'close'|translate }}
                        </button>
                    </div>

                </div>
            </div>

        </form>

    </div>
</div>

